import React from "react";

const PlaceofBattle = () => {
  return (
    <div>
      {/* click this to go here
      <div>news board</div> */}
    </div>
  );
};

export default PlaceofBattle;
